import "regenerator-runtime/runtime";
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { select, call } from 'redux-saga/effects';
import { userProfile, userPermissions } from 'redux/saga/entities/bound';
import { scrollToTop } from 'redux/saga/helpers';
import { isLoggedIn } from 'redux/saga/selectors';
import loginRedirectUrl from 'helpers/loginRedirectUrl';
import { memberStatus } from 'enums/memberStatus';
export var videosOnEnterSaga =
/*#__PURE__*/
regeneratorRuntime.mark(function videosOnEnterSaga(client, nextState, replaceState) {
  var redirect,
      profile,
      permissions,
      isActiveMember,
      isLivePermissioned,
      _args = arguments;
  return regeneratorRuntime.wrap(function videosOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          redirect = _args.length > 3 && _args[3] !== undefined ? _args[3] : '/';
          _context.next = 3;
          return select(isLoggedIn);

        case 3:
          if (_context.sent) {
            _context.next = 7;
            break;
          }

          _context.next = 6;
          return call(replaceState, loginRedirectUrl(nextState.location));

        case 6:
          return _context.abrupt("return", _context.sent);

        case 7:
          _context.next = 9;
          return call(scrollToTop);

        case 9:
          _context.next = 11;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 11:
          profile = _context.sent;
          _context.next = 14;
          return call(fetchEntityIfNeeded, userPermissions, [client, profile.id]);

        case 14:
          permissions = _context.sent;
          isActiveMember = profile.membership.status === memberStatus('ACTIVE');
          isLivePermissioned = permissions.feature_videos_live_tests;

          if (!(isActiveMember || isLivePermissioned)) {
            _context.next = 19;
            break;
          }

          return _context.abrupt("return");

        case 19:
          _context.next = 21;
          return call(replaceState, redirect);

        case 21:
          return _context.abrupt("return", _context.sent);

        case 22:
        case "end":
          return _context.stop();
      }
    }
  }, videosOnEnterSaga);
});
export var liveOnEnterSaga =
/*#__PURE__*/
regeneratorRuntime.mark(function liveOnEnterSaga(client, nextState, replaceState) {
  var redirect,
      profile,
      permissions,
      _args2 = arguments;
  return regeneratorRuntime.wrap(function liveOnEnterSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          redirect = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : '/';
          _context2.next = 3;
          return select(isLoggedIn);

        case 3:
          if (_context2.sent) {
            _context2.next = 7;
            break;
          }

          _context2.next = 6;
          return call(replaceState, loginRedirectUrl(nextState.location));

        case 6:
          return _context2.abrupt("return", _context2.sent);

        case 7:
          _context2.next = 9;
          return call(scrollToTop);

        case 9:
          _context2.next = 11;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 11:
          profile = _context2.sent;
          _context2.next = 14;
          return call(fetchEntityIfNeeded, userPermissions, [client, profile.id]);

        case 14:
          permissions = _context2.sent;

          if (!permissions.feature_videos_live_tests) {
            _context2.next = 17;
            break;
          }

          return _context2.abrupt("return");

        case 17:
          _context2.next = 19;
          return call(replaceState, redirect);

        case 19:
          return _context2.abrupt("return", _context2.sent);

        case 20:
        case "end":
          return _context2.stop();
      }
    }
  }, liveOnEnterSaga);
});
export var liveAdminOnEnterSaga =
/*#__PURE__*/
regeneratorRuntime.mark(function liveAdminSaga(client, nextState, replaceState) {
  var profile, permissions;
  return regeneratorRuntime.wrap(function liveAdminSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(isLoggedIn);

        case 2:
          if (_context3.sent) {
            _context3.next = 6;
            break;
          }

          _context3.next = 5;
          return call(replaceState, loginRedirectUrl(nextState.location));

        case 5:
          return _context3.abrupt("return", _context3.sent);

        case 6:
          _context3.next = 8;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 8:
          profile = _context3.sent;
          _context3.next = 11;
          return call(fetchEntityIfNeeded, userPermissions, [client, profile.id]);

        case 11:
          permissions = _context3.sent;

          if (permissions.feature_admin_video_kiosk) {
            _context3.next = 16;
            break;
          }

          _context3.next = 15;
          return call(replaceState, '/');

        case 15:
          return _context3.abrupt("return", _context3.sent);

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, liveAdminSaga);
});